export const LOGOS = {
    EP: 'europlatform',
    KPL: 'kaucyjni'
}
